import { useState } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';

interface Props {
  initialName: string;
  initialNote: string;
  disabled: boolean;
  onSubmit: (patch: { name: string; note: string }) => void;
}

export function TenantOverviewForm({ initialName, initialNote, disabled, onSubmit }: Props) {
  const [name, setName] = useState(initialName);
  const [note, setNote] = useState(initialNote);
  const dirty = name !== initialName || note !== initialNote;

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onSubmit({ name, note }); }}
      className="d-flex flex-column gap-2"
    >
      <FormGroup>
        <Label for="tof-name" className="mb-1">Nome</Label>
        <Input id="tof-name" value={name} onChange={(e) => setName(e.target.value)} disabled={disabled} maxLength={128} />
      </FormGroup>
      <FormGroup>
        <Label for="tof-note" className="mb-1">Note</Label>
        <Input id="tof-note" type="textarea" value={note} onChange={(e) => setNote(e.target.value)} disabled={disabled} maxLength={500} rows={3} />
      </FormGroup>
      <Button type="submit" color="primary" size="sm" disabled={disabled || !dirty} style={{ alignSelf: 'flex-end' }}>
        Salva modifiche
      </Button>
    </form>
  );
}
